export namespace SCHCTemplate {
  export const COMPRESSION_RULE = 'COMPRESSION_RULE';
  export const FRAGMENTATION_RULE = 'FRAGMENTATION_RULE';

  /*
    SCHC Template API expected body
  */
  export namespace API {
    export interface ParametersT {
      placeHolder: string;
      profileValue: any;
      value: any;
    }

    export namespace Fragmentation {
      export interface AOESpecs {
        disableAll1Payload: boolean | undefined;
        sendAckEveryWindow: boolean | undefined;
        disableBorrowPenultimateTile: boolean | undefined;
      }

      export interface OptAOESpecs {
        enableImplicitAck: boolean | undefined;
        sendAckEveryWindow: boolean | undefined;
      }

      export namespace Mode {
        export const NoACK = 'NoACK';
        export const ACKAlways = 'ACKAlways';
        export const ACKOnError = 'ACKOnError';
        export const OptimizedACKOnError = 'OptimizedACKOnError';
      }

      export namespace Qos {
        export const Undefined = 'Undefined';
        export const NoReliability = 'NoReliability';
        export const NetworkReliability = 'NetworkReliability';
        export const SystematicReport = 'SystematicReport';
      }

      export interface ParamT {
        mode: string; // NoACK,
        ruleIdSize: number;
        dTagSize: number;
        inactivityTime: number;
        micAlgo: string; // Default CRC32_IEEE
        winSize: number;
        /* ACK */
        retransmissionTime: number;
        all1RetransmissionTime: number;
        dTagReleaseTime: number;
        wSize: number;
        maxAck: number;
        enableShortSessionRetransmissionTime?: boolean;
        tileSize: number;
        aoeSpecs?: AOESpecs;
        optaoeSpecs?: OptAOESpecs;
        qos?: string;
      }
      export interface RuleT {
        ruleId: number;
        ruleEntries?: Array<any>,
        flows?: Array<any>,
        fragmentationParam: ParamT;
        direction?: string; // FRAG_UPLINK or ...
      }
    }

    export namespace Compression {
      export interface StackT {
        isIPCompressed: boolean;
        isUDPCompressed: boolean;
        isIPv6: boolean;
        application: string; // UNDEFINED
        stackType: string; // IP4_UDP
        isICMP: boolean;
        displayName: string; // IPv4_UDP
      }

      export namespace Flow {
        export interface RuleEntriesMatchingOperatorT {
          type: string; // EQUAL, IGNORE
          value: number;
        }
        export interface RuleEntriesT {
          fieldName: string; // IP4_VERSION
          fieldLength: number;
          fieldPosition: number;
          matchingOperator: RuleEntriesMatchingOperatorT;
          // NotSent, ComputeIP4HeaderLength, ComputeIP4Checksum
          // ComputeUDPLength, ComputeUDPChecksum
          cdactionFunction: string;
          targetValue: Array<string>;
          direction: string; // BI
          targetByte: Array<any>;
          description: string;
          displayName: string; // IPv4 Version
        }
        export interface ItemT {
          flowId: number;
          ruleEntries: Array<RuleEntriesT>;
        }
      }
      export interface RuleT {
        ruleId: number;
        ruleEntries: Array<any>;
        flows: Array<Flow.ItemT>;
        isDynamicContext: boolean;
        stack: StackT;
      }
    }

    export interface RuleT {
      ruleType: string; // COMPRESSION_RULE or FRAGMENTATION_RULE
      fragmentationRule?: Fragmentation.RuleT;
      compressionRule?: Compression.RuleT;
    }
    export interface BodyT {
      iD: string;
      /* General information */
      name: string;
      sCHCTemplateID: string;
      nonMatchingRule: number;
      /* Device type */
      unruly: boolean;
      legacy: boolean;
      /* Template context */
      description: string;
      /* Rules */
      deviceSchcRules: Array<RuleT>;
      /* Others */
      ruleIdSize: number;
      youpi: Array<any>;
      isNonLpwan: boolean;
      deviceContext: any;
      payloadPattern?: any;
      enableFragmentation: boolean;
      fragmentation: any;
      syncInterval: any;
      syncRetry: any;
      nbDeviceProfiles: string;
      parameters: Array<ParametersT>;
      /* Output */
      createdBy?: string;
      lastUpdated: string;
      organization: string;
    }
  }

  /*
    Form Values format from
    React Hook Form
  */
  export namespace Form {
    export interface CompressionItem
      extends SCHCTemplate.API.Compression.Flow.RuleEntriesT {
      // if -> the field is not displayed in the form : Undefined
      // else -> RuleEntriesT.targetValue[0]
      value: string | undefined;
    }
    export interface FragmentationItem
      extends SCHCTemplate.API.Fragmentation.ParamT {
      direction: string;
      disableAll1Payload?: boolean;
      sendAckEveryWindow?: boolean;
      enableImplicitAck?: boolean;
      optSendAckEveryWindow?: boolean;
    }
    export interface RuleT {
      ruleId: string;
      ruleType: string;
      /* Fragmentation Fields */
      fragmentation?: FragmentationItem;
      /* Compression Stack Fields */
      stack?: string;
      fields?: Array<CompressionItem>;
    }
    export type ValuesT = {
      name: string;
      sCHCTemplateID: number;
      /* === */
      nonMatchingRule: number;
      unruly: boolean;
      legacy: boolean;
      description: string;
      rules: Array<RuleT>;
      /* === */
      createdBy?: string;
      payloadPattern?: {};
    }
  }
}

export default SCHCTemplate;
